import { env } from '../../config/env'
import { Loader } from '@120wateraudit/envirio-components/dist/components/Loader'
import styles from './LocationsCard.module.scss'
import { GoogleMap } from '@120wateraudit/envirio-components/dist/components/GoogleMap'
import * as React from 'react'
import { colors } from '@120wateraudit/envirio-components'
import { MapMarker } from '@120wateraudit/envirio-components/dist/components/GoogleMap/EnvirioMarker'
import { InfoWindow } from '../InfoWindow/InfoWindow'
import { WaterTestingMapPinInfoQuery } from '../../rpcs/WaterTestingMapPinInfoQuery'
import { WaterTestingMapPinsQuery } from '../../rpcs/WaterTestingMapPinsQuery'

interface LocationsCardProps {
  accountId: number
}

interface MarkerArg {
  lat: number | null
  lng: number | null
  facilityId: number
}

interface InfoMapMarker extends MapMarker<{ facilityId: number }> {}

export default class LocationsCard extends React.Component<LocationsCardProps> {
  constructor(props: LocationsCardProps) {
    super(props)
  }

  render() {
    const { accountId } = this.props

    return (
      <WaterTestingMapPinsQuery variables={{ accountId }}>
        {({ data, loading }) => {
          if (loading) {
            return <Loader />
          }

          if (
            !data ||
            !data.waterTestingMapPins ||
            !Array.isArray(data.waterTestingMapPins) ||
            data.waterTestingMapPins.length === 0
          ) {
            return null
          }

          const mapMarkers = data.waterTestingMapPins.map(this.marker as any)

          return (
            <div className={styles.locationsCard + ' buildingBlock'}>
              <h2>Water Testing Locations</h2>
              <div className={styles.mapContainer}>
                <GoogleMap
                  apiKey={env.googleMapsApiKey}
                  mapId={env.googleMapId}
                  defaultZoom={7}
                  mapType="infoWindow"
                  renderInfoWindow={this.renderInfoWindow}
                  center={{
                    lat: 40.7128,
                    lng: 74.006
                  }}
                  markers={mapMarkers as InfoMapMarker[]}
                />
              </div>
              <p className={styles.mapDisclaimer}>
                * Some facilities may not appear on map. Please see the table
                below for a full list of facilities.
              </p>
            </div>
          )
        }}
      </WaterTestingMapPinsQuery>
    )
  }

  // TODO: Fix the typing here.
  private renderInfoWindow = ({ facilityId }: any) => {
    return (
      <>
        <WaterTestingMapPinInfoQuery variables={{ facilityId }}>
          {({ data, error, loading }) => {
            if (loading) {
              return <Loader />
            }

            if (error || !data || !data.info) {
              return null
            }

            return (
              <InfoWindow facilityId={facilityId} facilityInfo={data.info} />
            )
          }}
        </WaterTestingMapPinInfoQuery>
      </>
    )
  }
  private marker = ({ lat, lng, facilityId }: MarkerArg): InfoMapMarker => {
    return {
      position: {
        lat,
        lng
      },
      info: {
        facilityId
      },
      color: colors.primary
    }
  }
}
